import React from 'react';
import { WarningSvg } from 'src/assets/dynamicSvg';
import * as S from './Alert.styles';

export { AlertView } from './Alert.styles';

interface AlertTitleProps {
  children: React.ReactNode;
}

export const AlertTitle: React.FC<AlertTitleProps> = ({ children }) => {
  return (
    <S.AlertTitleContainer>
      <WarningSvg style={{ minWidth: '20px' }} />
      {children}
    </S.AlertTitleContainer>
  );
};
